import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { getData } from "./api/indexedDBHandler";
import Loading from "./Loading/Loading";

const PrivateRoute = ({ children }) => {
  const [isUserAuthenticated, setIsUserAuthenticated] = useState(null); // null пока загружаем

  useEffect(() => {
    const checkUserAuthentication = async () => {
      try {
        const userRecords = await getData("user", "created", true);
        setIsUserAuthenticated(userRecords && userRecords.length > 0); // Установите состояние в зависимости от данных
      } catch (error) {
        console.error("Error fetching user data:", error);
        setIsUserAuthenticated(false); // Если возникла ошибка
      }
    };

    checkUserAuthentication();
  }, []);

  // Пока идет асинхронная операция, вы можете показывать индикатор загрузки или же ничего не рендерить.
  if (isUserAuthenticated === null) {
    return <Loading />; // Или любой элемент, показывающий, что идет загрузка
  }

  // Вернуть `children` если пользователь аутентифицирован
  return isUserAuthenticated ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
